import React from "react";
import { Input, Select, DatePicker, TimePicker, AutoComplete } from "antd";
import {
    Checkbox,
    FormControlLabel,
    NativeSelect,
    TextareaAutosize,
    Input as MaterialInput,
    RadioGroup,
    Radio,
} from "@material-ui/core";

import "./styles.css";
import useStyles from "./styles";

const Option = { Select };

function InputBaseField({ id, placeholder, name, value, type, IsDisabled, onClick, onChange, onBlur, onFocus, MaxLength, MinLength, Suffix, max, min, ...props }) {

    const onChangeEvent = (event) => {
        onChange(event);
    };
    return (
        <Input
            id={id}
            name={name}
            value={value}
            type={type}
            disabled={IsDisabled}
            placeholder={placeholder}
            onChange={onChangeEvent}
            className="custom-input"
            autoComplete={"off"}
            onBlur={onBlur}
            onFocus={onFocus}
            maxLength={MaxLength}
            minxLength={MinLength}
            suffix={Suffix}
            max={max}
            min={type == 'Date' ? props.minDate : min}
        />
    )
}

function CheckboxField({ id, name, checked, label, labelPlacement, value, color, onChange, IsDisabled, ...props }) {
    var classes = useStyles();

    const onChangeEvent = (event) => {
        if (onChange)
            onChange(event);
    };

    return (
        <>
            <FormControlLabel
                control={
                    <Checkbox
                        disabled={IsDisabled}
                        color={color}
                        className={classes.checkBoxBtn}
                        onChange={onChangeEvent}
                        name={name}
                        id={id}
                        checked={checked}
                        value={value}
                        {...props}

                    />
                }
                label={label}
                labelPlacement={labelPlacement}
            />

        </>
    );
}

function DatePickerField({ id, name, value, defaultvalue, InputRef, pickertype, IsDisabled, size, onClick, onChange, onOK, onBlur, onFocus, ...props }) {
    var classes = useStyles();

    const onChangeEvent = (event) => {
        onChange(event);
    };
    // const onChangeEvent = (date, dateString) => {
    //     onChange(name, dateString);
    // };
    return (
        <input
            id={id}
            name={name}
            value={value}
            ref={InputRef}
            type="date"
            min={props.minDate}
            max="2099-12-31"
            // className={classes.baseInput}
            onChange={onChangeEvent}
            disabled={IsDisabled}
            className={classes.dateInput}
        />
        // <DatePicker
        //     id={id}
        //     name={name}
        //     value={value}
        //     picker={pickertype}
        //     format='YYYY-MM-DD'
        //     disabled={IsDisabled}
        //     defaultValue={defaultvalue}
        //     onChange={onChangeEvent}
        //     className="custom-input"
        //     {...props} />
    )
}
function TimePickerField({ id, name, value, defaultvalue, IsDisabled, size, onClick, onChange, ...props }) {

    const onChangeEvent = (time, timeString) => {

        onChange(name, timeString);
    };
    return (
        <TimePicker
            id={id}
            name={name}
            value={value}
            format="HH:mm:ss"
            disabled={IsDisabled}
            defaultValue={defaultvalue}
            onChange={onChangeEvent}
            className="custom-input"
            {...props} />
    )
}
function SelectField({ id, name, value, options, onChange, IsDisabled, isClearAble, placeholder, defaultvalue, InputRef, ...props }) {
    var classes = useStyles();
    if (value === null || value === undefined)
        value = "";

    const onChangeEvent = (event) => {
        onChange(event);
    };

    return (<NativeSelect
        id={id}
        disableUnderline
        className={classes.selectBaseInput}
        onChange={onChangeEvent}
        name={name}
        value={value}
        inputRef={InputRef}
        inputProps={InputRef}
        input={<MaterialInput inputRef={InputRef}
            disabled={IsDisabled}
        />

        }
        {...props}
    >
        {
            placeholder ? (<option value="">{placeholder}</option>) : ('')
        }
        {
            options.map((option, i) => (
                <option key={i} value={option.value}>{option.label}</option>
            ))
        }
    </NativeSelect>

    );
}
function AutoCompleteField({ id, name, value, options, handleChange, IsDisabled, isClearAble, placeholder, defaultvalue, ...props }) {
    const handleSearch = (value) => {
        handleChange(name, value);
    };
    return (
        <>
            <AutoComplete
                defaultValue={defaultvalue}
                onSearch={handleSearch}
                placeholder={placeholder}
                name={name}
                onChange={handleSearch}
                //allowClear={isClearAble ? false : true}
                value={value}
                className="custom-select-input"
                disabled={IsDisabled}
                options={options}
                filterOption={true}
            >
                {options.map((option) => (
                    <Option key={option.value} value={option.value}>
                        {option.label}
                    </Option>
                ))}
            </AutoComplete>
        </>
    );
}

function TextareaField({ id, name, value, MaxLength, MinLength, placeholder, rowsMin, onChange, InputProps, Disabled, ...props }) {
    var classes = useStyles();

    const onChangeEvent = (event) => {
        onChange(event);
    };

    return (
        <>
            <TextareaAutosize
                id={id}
                className={classes.baseTextarea}
                rowsMin={rowsMin}
                placeholder={placeholder}
                onChange={onChangeEvent}
                name={name}
                value={value}
                maxLength={MaxLength}
                disabled={Disabled}
                inputProps={{ minlength: MinLength, autoComplete: "off", ...InputProps }}
                rows={5}
                {...props}

            />

        </>
    );
}
function RadioboxField({ id, name, value, options, labelPlacement, onChange, ...props }) {
    var classes = useStyles();

    const onChangeEvent = (event) => {
        onChange(event);
    };

    return (
        <>
            <RadioGroup
                aria-label={id}
                className={classes.radioBtn}
                name={name}
                value={value}

                row
                onChange={onChangeEvent}
                {...props}
            >
                {options.map((option, i) => (
                    <FormControlLabel key={i} labelPlacement={labelPlacement} value={option.value} control={<Radio color="primary" />} label={option.label} disabled={props.Disabled === undefined ? false : props.Disabled} />
                ))}
            </RadioGroup>
        </>
    );
}

export { InputBaseField, SelectField, DatePickerField, TimePickerField, AutoCompleteField, CheckboxField, TextareaField, RadioboxField };